import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { PageShell } from "./PageShell";
import { EmptyState } from "./States";

/** Replaces the bare <Alert type="error"> that four pages used as their
 *  permission guard. Same guard, designed. */
export const NoAccess = ({ what = "this page" }: { what?: string }) => {
  const navigate = useNavigate();
  return (
    <PageShell kind="detail" kicker="Restricted" title="Not available">
      <EmptyState
        tone="error"
        title={`You don't have access to ${what}`}
        description="This area is internal to the Quattro team. If you need something from it, raise a ticket and we'll pick it up."
        actions={<Button type="primary" onClick={() => navigate("/support")}>Go to support</Button>}
      />
    </PageShell>
  );
};
